'use client';

import { useSiteDomain } from '@/contexts/domain/hooks';
import { clsx } from 'clsx';
import Image from 'next/image';

interface Props {
  parentId: number;
  imageId: number;
  width: number;
  className?: string;
  priority?: boolean;
  alt?: string;
  height?: number | string;
}

const imageLoader = ({
  src,
  width,
  quality,
  height,
}: {
  src: string;
  width: number;
  quality?: number;
  height?: number | string;
}) => {
  const params = new URLSearchParams({
    w: `${width}`,
    h: `${height !== undefined && height === width ? height : Math.round((width * 2) / 3)}`,
    fit: 'crop',
    fm: 'webp',
    q: `${quality || 100}`,
  });

  return `${src}?${params.toString()}`;
};

const ProductImage = ({
  parentId,
  imageId,
  width,
  className,
  priority,
  alt,
  height,
}: Props) => {
  const domain = useSiteDomain();
  const imageSrc = `${process.env.NEXT_PUBLIC_IMAGES_URL?.replace(
    '{domain}',
    domain,
  )}/products/${parentId}/${imageId}.webp`;

  return (
    <Image
      loader={(e) =>
        imageLoader({
          src: imageSrc,
          width: width ?? e.width,
          height,
          quality: 100,
        })
      }
      src={imageSrc}
      priority={priority}
      alt={alt !== undefined ? alt : 'product image'}
      className={clsx('aspect-3/2 rounded-s', className)}
      width={width}
      height={height ? Number(height) : (width / 3) * 2}
    />
  );
};

export default ProductImage;
